import {Injectable} from '@angular/core';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Burly} from 'kb-burly';
import {RogueMetrics, CrtMonthlyAggregate} from '../models';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TorchCrtMetricsService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  public getRogueMetrics(): Observable<RogueMetrics[]> {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/crt-metrics/rogue-metrics')
      .get;

    return this.httpClient.get<{ data: RogueMetrics[] }>(endpointURL).pipe(
      map(r => r.data)
    );
  }

  public getMonthlyAggregate(): Observable<CrtMonthlyAggregate[]> {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/crt-metrics/monthly-aggregate')
      .get;

    return this.httpClient.get<{ data: CrtMonthlyAggregate[] }>(endpointURL).pipe(
      map(r => r.data)
    );
  }
}
